<template>
    <div :class="[parentClass, 'form-group']">
        <label
            v-if="label"
            class="form-group-label d-flex align-items-center"
            :for="uniqueId"
        >
            {{ label }}
            <ui-icon
                v-if="tooltip"
                icon="info"
                :content="tooltip"
                class="ml-2"
                v-tippy
            />
        </label>
        <div class="input-group">
            <textarea
                v-model="inputValue"
                v-bind="$attrs"
                @input="handleInput"
                @focusin="focus = true"
                @focusout="focus = false"
                class="form-control"
                :placeholder="placeholder || label"
                :id="uniqueId"
            ></textarea>
        </div>
    </div>
</template>

<script>
    import UiIcon from './icon.vue';

    export default {
        name: 'UiTextarea',
        inheritAttrs: false,
        components: {
            UiIcon,
        },
        props: {
            label: {
                type: String,
                default: null,
            },
            parentClass: {
                type: String,
                default: '',
            },
            placeholder: {
                type: String,
                default: null,
            },
            tooltip: {
                type: String,
                default: null,
            },
            value: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                focus: false,
                inputValue: this.value,
            };
        },
        computed: {
            moveLabelToTop() {
                return this.focus || !!this.inputValue;
            },

            uniqueId() {
                return this._uid;
            },
        },
        methods: {
            handleInput() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value(newValue) {
                this.inputValue = newValue;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .input-group .form-control {
        height: auto;
        padding: 16px;
        line-height: normal;
    }
</style>
